var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"layout-all"},[_c('v-icon',{staticClass:"icon-title mr-5"},[_vm._v(_vm._s(_vm.iconTitle))]),_c('div',{staticClass:"title-menu"},[_vm._v(_vm._s(_vm.titleMenu))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }